import { render, staticRenderFns } from "./stages-alias-modal.vue?vue&type=template&id=50763372&"
import script from "./stages-alias-modal.ts?vue&type=script&lang=ts&"
export * from "./stages-alias-modal.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports